import { getToken } from "../utils/authHelpers";
import { request } from "../utils/requestHelpers";
import CitySerializer from "../serializers/CitySerializer";
import McleodStateSerializer from "../serializers/McleodStateSerializer";
import LocationSerializer from "../serializers/LocationSerializer";

export default class LocationRepository {
  LOCATIONS_BASE = "/api/locations";

  constructor() {
    this.headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer"
    };
  }

  async getLocation(instance, params) {
    const token = await getToken(instance);
    const path = `${this.LOCATIONS_BASE}/location?${params}`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers
    });

    return Promise.resolve(LocationSerializer.deSerialize(req.location));
  }

  async findCities(instance, params) {
    const token = await getToken(instance);
    const path = `${this.LOCATIONS_BASE}/cities?${params}*`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers
    });

    if (req.cities) {
      return Promise.resolve(
        req.cities.map(city => ( 
          CitySerializer.deSerialize(city)
        ))
      );
    } else {
      return Promise.resolve([]);
    }
  }

  async updateCity(instance, payload) {
    const token = await getToken(instance);
    const path = `${this.LOCATIONS_BASE}/cities`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      method: "PUT",
      headers: this.headers,
      body: JSON.stringify({ city: CitySerializer.serialize(payload) })
    });

    return Promise.resolve(CitySerializer.deSerialize(req.city));
  }

  async findStates(instance, params) {
    const token = await getToken(instance);
    const path = `${this.LOCATIONS_BASE}/states?${params}*`;
    this.headers.Authorization = `Bearer ${token}`;

    const req = await request(path, {
      headers: this.headers
    });

    if (req.states) {
      return Promise.resolve(
        req.states.map(state => ( 
          McleodStateSerializer.deSerialize(state)
        ))
      );
    } else {
      return Promise.resolve([]);
    }
  }
}